var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AlertAFY, ButtonAFY, FormBenefitAFY, FormPrimeAFY, FormsPlansAFY, IconAFY, icons, severity, sizes, sizesIcon, variants, variantsAlert, ModalComponentAFY, ContextMenuAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { Title } from "../../../components/layout/style";
import { Container, ContainerAlert, ContainerIcon, ContainerTitle, } from "./style";
import { themeCore } from "../../../assets/themes/theme";
export var PlanCreationView = function (props) {
    var convertToSelectedItems = function () {
        var _a, _b, _c;
        var items = [];
        var result = "";
        if (((_b = (_a = props.coverageTypesPrime) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
            (_c = props.coverageTypesPrime) === null || _c === void 0 ? void 0 : _c.map(function (item) {
                var _a;
                items.push((_a = item.name) !== null && _a !== void 0 ? _a : "");
            });
            result = items.join(", ");
            return result;
        }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(ModalComponentAFY, __assign({ openModal: props.openModalBenefit, backgroundColor: "#ffffff", onClose: props.onCloseModalBenefit, modalWidth: 490, border: 0 }, { children: _jsx(FormBenefitAFY, { title: "Información del beneficio", dataFormBenefits: props.dataFormBenefits, onClickCancel: props.onCloseModalBenefit, onNext: props.onSaveBenefit }) })), _jsx(ModalComponentAFY, __assign({ openModal: props.openModalPrime, backgroundColor: "#ffffff", onClose: props.onCloseModalPrime, modalWidth: 490, border: 0 }, { children: _jsx(FormPrimeAFY, { title: "Información de la prima", TypeList: props.paymentModeList, CoverTypeList: props.coverageTypesPrime, dataFormPrimes: props.dataFormPrimes, onClickCancel: props.onCloseModalPrime, onNext: props.onSavePrime }) })), _jsxs(ContainerAlert, { children: [_jsx(Container, { children: _jsx(ButtonAFY, { variant: variants.text, label: "Regresar", icon: icons.ArrowBackIosNew, size: sizes.small, color: themeCore.colors.primaryText, onClick: props.onClickBack }) }), _jsx("div", __assign({ style: { marginTop: "15px", marginBottom: "-15px" } }, { children: _jsx(AlertAFY, { title: "", isOpen: props.showAlert, setAutoClose: props.autoCloseActive, autoClose: props.autoClose, description: "", iconClose: icons.Close, iconCloseColor: "#fff", onClose: function () {
                                var _a;
                                (_a = props.setShowAlert) === null || _a === void 0 ? void 0 : _a.call(props, false);
                            }, severity: severity.info, variant: variantsAlert.filled, backgroundColor: "#637985", iconColor: "#FFF", spacing: 0, textColor: "#fff", width: "100%" }) }))] }), _jsxs(ContainerTitle, { children: [_jsx(Title, { children: "Planes" }), props.idPlan && props.isEdit !== "true" && (_jsx(ContainerIcon, { children: _jsx(IconAFY, { icon: icons.Visibility, size: sizesIcon.medium, color: "#3A56A1" }) }))] }), _jsx(FormsPlansAFY, { handleChangeTab: function (e, tab) { localStorage.setItem("tab", tab.toString()); }, permissions: props.permissions, coverageTypes: props.coverageType, onChangeSelect: props.onUpdateCoverTypeSelected, onNext: props.handleSubmitPlan, onSendPlanForm: props.handleSubmitPlan, onSendPrimes: props.handleSubmitPlan, onSendBenefits: props.handleSubmitPlan, onClickAddBenefits: props.onClickAddBenefits, onClickAddPrimes: props.onClickAddPrimes, labelButtonAddPlan: "Agregar planes", labelButtonAdd: "Guardar plan", labelButtonAddBenefits: "Agregar beneficios", labelButtonAddPrimes: "Agregar primas", titleButtonAdd: "Agregar", titleButtonCancel: "Cancelar", benefitsTitle: "Beneficios", primesTitle: "Tabla de primas", textLegend: "Para crear un beneficio, primero es necesario crear un plan.", panelActive: props.panelActive, disableBenefits: props.disableBenefits, disablePrimes: props.disablePrimes, activateEditMode: props.activateEditMode, showCancelButton: props.activateEditMode, formsCompleted: [true], showButtonsActions: true, seeButtonAddPlans: false, showButtonAddBenefits: true, showButtonAddPrimes: true, selectedItems: convertToSelectedItems(), textLegendColor: "#bcbcbc", 
                //\
                typeList: props.coverageTypeList, columnsBenefits: [
                    {
                        field: "type",
                        headerName: "Acciones",
                        width: 100,
                        renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                                    {
                                        disabled: false,
                                        icon: {
                                            color: "#006ac6",
                                            icon: icons.Edit,
                                            size: sizesIcon.standard,
                                        },
                                        id: "edit",
                                        name: "Editar",
                                    },
                                    {
                                        disabled: false,
                                        icon: {
                                            color: "#006ac6",
                                            icon: icons.DeleteForever,
                                            size: sizesIcon.standard,
                                        },
                                        id: "delete",
                                        name: "Eliminar",
                                    }
                                ], onClickContextMenu: function (item) {
                                    return props.handleClickContextMenu(item, params.row, "benefits");
                                }, sizeIcon: sizesIcon.standard }) }))); }
                    },
                    {
                        field: "description",
                        headerName: "Descripción",
                        flex: 1,
                        width: 150,
                    },
                    {
                        field: "value",
                        headerName: "Valor",
                        flex: 1,
                        width: 150,
                    },
                ], rowsBenefits: props.benefitsData, columnsPrimes: [
                    {
                        field: "type",
                        flex: 1,
                        headerName: "Acciones",
                        width: 150,
                        renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                                    {
                                        disabled: false,
                                        icon: {
                                            color: "#006ac6",
                                            icon: icons.Edit,
                                            size: sizesIcon.standard,
                                        },
                                        id: "edit",
                                        name: "Editar",
                                    },
                                    {
                                        disabled: false,
                                        icon: {
                                            color: "#006ac6",
                                            icon: icons.DeleteForever,
                                            size: sizesIcon.standard,
                                        },
                                        id: "delete",
                                        name: "Eliminar",
                                    }
                                ], onClickContextMenu: function (item) {
                                    return props.handleClickContextMenu(item, params.row, "primes");
                                }, sizeIcon: sizesIcon.standard }) }))); }
                    },
                    {
                        field: "minAge",
                        headerName: "Edad mínima",
                        flex: 1,
                        width: 150,
                    },
                    {
                        field: "maxAge",
                        headerName: "Edad máxima",
                        flex: 1,
                        width: 150,
                    },
                    {
                        field: "paymentMode",
                        headerName: "Periodicidad",
                        flex: 1,
                        width: 150,
                    },
                    {
                        field: "coverType",
                        headerName: "Tipo de cobertura",
                        flex: 1,
                        width: 150,
                    },
                    {
                        field: "price",
                        headerName: "Prima",
                        flex: 1,
                        width: 150,
                    },
                ], rowsPrimes: props.scenarios, paymentModeOption: [], dataPlanCreationForm: props.planData })] }));
};
